export const customerTypes = Object.freeze({
  PROVIDER: "provider",
  SPECIALTY: "specialty",
  RETAIL: "retail"
});
